// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    RESET_PASSWORD_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    resetPasswordResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* resetPassword({ payload }) {
    try {
        let QUERY = `
            mutation resetCompanyPassword ($id: Int!) {
                result: resetCompanyPassword (id: $id)
            }
        `;
        if (payload?.entityName === 'User') {
            QUERY = `
                mutation resetUserPassword ($id: Int!) {
                    result: resetUserPassword (id: $id)
                }
            `;
        }

        if( payload?.entityName === 'SubUser') {
            QUERY = `
                mutation resetSubUserPassword ($id: Int!) {
                    result: resetSubUserPassword (id: $id)
                }
            `;
        }
        
        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload?.id,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(resetPasswordResult({ reset: data?.result }))


    } catch (exc) {
        console.log("exc", exc);
        yield put(resetPasswordResult({ reset: false, error: exc }))
        //ExceptionManager(exc, 'Modules/accounts/views/components/resetPassword/redux/saga', 'resetPassword');
    }
}

function* watchMethods() {
    yield takeEvery(RESET_PASSWORD_REQUEST, resetPassword);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}